class UserService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.authenticationService = authenticationService;
        this.token = this.authenticationService.getToken();
        this.globalConstants = globalConstants;
    }

    getTrainees(query) {
        //TODO: probably nicer way of doing queryString
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users?userType=4',
            params: query
        });
    }

    getTrainers(query) {
        //TODO: probably nicer way of doing queryString
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users?userType=3',
            params: query
        });
    }

    getAdmins(query) {
        //TODO: probably nicer way of doing queryString
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users?userType=2',
            params: query
        });
    }

    getByClientId(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/getbyclientid',
            params: query
        });
    }

    getTrainersByClientId(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/gettrainersbyclientid',
            params: { id: id}
        });
    }

    getTrainersBySubscriptionId() {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/gettrainersbysubscriptionid'
        });
    }


    getAdminBySubscriptionId(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/getadminbysubscriptionid?usertype=2',
            params: { id : id}
        });
    }

    getByIds(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/getByIds',
            params: query
        });
    }

    
    getAll(query) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users',
            params: query
        });
    }

    get(id) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/get/' + id
        });
    }

    delete(id) {
        return this.$http({
            method: 'DELETE',
            url: this.globalConstants.ApiBaseUrl + '/api/users/' + id
        });
    }

    //Gets current user
    getCurrent() {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/users/GetCurrent'
        });
    }

    add(user) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/users',
            data: user 
        });
    }

    insertTrainer(user) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/users/inserttrainer',
            data: user
        });
    }

    updateTrainer(user) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/users/updatetrainer',
            data: user
        });
    }

    insertTrainee(user) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/users/inserttrainee',
            data: user
        });
    }

    updateTrainee(user) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/users/updatetrainee',
            data: user
        });
    }

    insertSubscriptionAdmin(user) {
        return this.$http({
            method: 'POST',
            url: this.globalConstants.ApiBaseUrl + '/api/users/insertsubscriptionadmin',
            data: user
        });
    }

    updateSubscriptionAdmin(user) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/users/updatesubscriptionadmin',
            data: user
        });
    }

    update(user) {
        return this.$http({
            method: 'PUT',
            url: this.globalConstants.ApiBaseUrl + '/api/users',
            data: user
        });
    }
}

export default UserService;


// WEBPACK FOOTER //
// ./src/js/services/user.service.js